export enum ContactsTab {
  Saved = 'saved',
  UnknownAddresses = 'unknown-addresses',
}

export const contactsTabTitles = {
  [ContactsTab.Saved]: 'Saved',
  [ContactsTab.UnknownAddresses]: 'Unknown Addresses',
}
